module.exports = __webpack_public_path__ + "assets/img/f1.27588e8f.png";